import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import {
  getCustomerContact,
  deleteCustomerContact,
  generateSendCustomerPortalAccess,
} from "../../../../../services/sales/customerService";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import CustomerContactForm from "./customerContactForm";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { whatsappChat } from "../../../../../utils/utils";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const CustomerContacts = ({
  customerID,
  viewAuth = false,
  editAuth = false,
}) => {
  const { reload } = useGlobalData();
  const [openContactForm, setOpenContactForm] = useState(false);
  const [contact, setContact] = useState({});
  const [action, setAction] = useState("");
  const [auth, setAuth] = useState({});
  const [customerContact, setCustomerContact] = useState([]);
  useEffect(() => {
    getCustomerContactData();
  }, [customerID, reload]);

  async function getCustomerContactData() {
    const response = await getCustomerContact(customerID);
    const { data, auth } = response.data;
    setAuth(auth);
    setCustomerContact(data.contacts);
  }

  const customerContactDetailColumn = [
    {
      header: "Customer Portal Access",
      field: "lockedStatusName",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <CustomDataTable
            data={customerContact}
            dataDetailColumns={customerContactDetailColumn}
            onRefreshData={() => {
              getCustomerContactData();
            }}
            buttons={
              editAuth
                ? [
                    {
                      name: "New Contact",
                      icon: "fas fa-plus-circle",
                      color: "primary",
                      onClick: () => {
                        setAction("create");
                        setContact({});
                        setOpenContactForm(true);
                      },
                    },
                  ]
                : []
            }
            columns={[
              {
                header: "Contact Name",
                field: "contactName",
                body: (rowData) => {
                  return (
                    <React.Fragment>
                      {rowData.standardFlag ? (
                        <React.Fragment>
                          <span>
                            <BootstrapTooltip title="Standard record protection">
                              <span className="mr-2">
                                <i className="fas fa-shield-alt kt-font-brand"></i>
                              </span>
                            </BootstrapTooltip>
                            <span>{rowData.contactName}</span>
                          </span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <ResponsiveEllipsis
                            text={rowData.contactName}
                            maxLine="1"
                          />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  );
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Position",
                field: "position",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.position} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Phone Number",
                field: "contactPhone",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.contactPhone}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Email",
                field: "contactEmail",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.contactEmail}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.contactEmail !== "" ? (
                      <BootstrapTooltip title="Generate & Send Customer Portal Access Via Email">
                        <button
                          type="button"
                          onClick={(e) => {
                            Swal.mixin({
                              customClass: {
                                confirmButton:
                                  "btn btn-success btn-md btn-pill btn-bold",
                                cancelButton:
                                  "btn btn-danger btn-md btn-pill btn-bold",
                              },
                              buttonsStyling: false,
                            })
                              .fire({
                                title:
                                  "Are you sure want to send the newly generated Customer Portal access to this contact email ?",
                                text:
                                  "Please note that you are responsible for this action",
                                icon: "question",
                                showCloseButton: true,
                                showCancelButton: true,
                                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, send it`,
                                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                                reverseButtons: true,
                              })
                              .then((result) => {
                                if (result.isConfirmed) {
                                  generateSendCustomerPortalAccess(
                                    rowData
                                  ).then((response) => {
                                    Swal.mixin({
                                      customClass: {
                                        confirmButton:
                                          "btn btn-success btn-md btn-pill btn-bold",
                                      },
                                      buttonsStyling: false,
                                    }).fire({
                                      title: "Sent",
                                      html: response.data.message,
                                      icon: "success",
                                      showCloseButton: true,
                                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                    });
                                    getCustomerContactData();
                                  });
                                } else if (
                                  result.dismiss === Swal.DismissReason.cancel
                                ) {
                                  Swal.mixin({
                                    customClass: {
                                      confirmButton:
                                        "btn btn-success btn-md btn-pill btn-bold",
                                    },
                                    buttonsStyling: false,
                                  }).fire({
                                    title: "Cancelled",
                                    text: "No change has been made",
                                    icon: "info",
                                    showCloseButton: true,
                                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                  });
                                }
                              });
                          }}
                          className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-key"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {rowData.contactPhone !== "" ? (
                      <BootstrapTooltip title="Whatsapp Chat Customer Contact">
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            whatsappChat(
                              rowData.contactPhone,
                              `Hi customer ${rowData.contactName}`
                            );
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="flaticon-whatsapp"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {editAuth ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Edit Customer Contact">
                          <button
                            type="button"
                            onClick={() => {
                              setAction("edit");
                              setContact(rowData);
                              setOpenContactForm(true);
                            }}
                            className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                    <BootstrapTooltip title="Customer Contact Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setAction("detail");
                          setContact(rowData);
                          setOpenContactForm(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    {editAuth && rowData.standardFlag === false ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Delete Customer Contact">
                          <button
                            type="button"
                            onClick={() =>
                              deleteCustomerContactData(rowData.ID)
                            }
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </div>
      </div>
      <DialogLayout
        open={openContactForm}
        title={
          action === "detail"
            ? "Customer Contact Detail"
            : "Customer Contact Form"
        }
        onCloseDialog={() => {
          setOpenContactForm(false);
        }}
        maxWIdth="sm"
      >
        <CustomerContactForm
          customerID={customerID}
          action={action}
          contact={contact}
          onConfirmSave={() => {
            getCustomerContactData();
            setOpenContactForm(false);
          }}
          onCloseDialog={() => {
            setOpenContactForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function deleteCustomerContactData(customerContactID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Customer Contact ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteCustomerContact(customerContactID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getCustomerContactData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
};

export default CustomerContacts;
